import {
  GET_MESSAGE_GROUPS_REQ,
  GET_MESSAGE_GROUPS_SUCCESS,
  GET_MESSAGE_GROUPS_FAIL,
  GET_OVERALL_MESSAGE_GROUPS_SUCCESS,
  GET_OVERALL_MESSAGE_GROUPS_FAIL,
  CREATE_MESSAGE_GROUP_REQ,
  CREATE_MESSAGE_GROUP_SUCCESS,
  CREATE_MESSAGE_GROUP_FAIL,
  UPDATE_MESSAGE_GROUP_REQ,
  UPDATE_MESSAGE_GROUP_SUCCESS,
  UPDATE_MESSAGE_GROUP_FAIL,
  DELETE_MESSAGE_GROUP_REQ,
  DELETE_MESSAGE_GROUP_SUCCESS,
  DELETE_MESSAGE_GROUP_FAIL,
} from "../constants/messageGroups";

import { toast } from "react-toastify";

import api from "../../services/api";

export const getOverallMessageGroups =
  (totalPage) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      const limit = 100;
      const getMessageGroups = async (page) => {
        const skip = limit * (parseInt(page) - 1);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.gmBackendToken}`,
          },
        };
        const { data } = await api.get(
          `/api/message-groups?skip=${skip || 0}&limit=${limit}`,
          config
        );
        return data;
      };
      let allMessageGroups = [];
      let totalPage = 1;
      const firstPageResult = await getMessageGroups(1);
      if (firstPageResult?.success === true) {
        allMessageGroups = allMessageGroups.concat(
          firstPageResult?.body?.messageGroupsList
        );
        totalPage =
          firstPageResult.body?.count % limit === 0
            ? firstPageResult?.body?.count / limit
            : parseInt(firstPageResult.body?.count / limit) + 1;
      }
      // console.log("totalPage", totalPage);
      for (let i = 2; i <= parseInt(totalPage); i++) {
        const res = await getMessageGroups(i);
        if (res?.success === true) {
          allMessageGroups = allMessageGroups.concat(
            res?.body?.messageGroupsList
          );
        }
      }
      // console.log("allMessageGroups", allMessageGroups);
      dispatch({
        type: GET_OVERALL_MESSAGE_GROUPS_SUCCESS,
        payload: allMessageGroups,
      });
    } catch (error) {
      dispatch({
        type: GET_OVERALL_MESSAGE_GROUPS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const getAllMessageGroups =
  (skip, limit) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_MESSAGE_GROUPS_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.get(
        `/api/message-groups?skip=${skip || 0}&limit=${limit || 10}`,
        config
      );

      dispatch({
        type: GET_MESSAGE_GROUPS_SUCCESS,
        payload: { body: data?.body, skip: skip || 0, limit: limit || 10 },
      });
    } catch (error) {
      dispatch({
        type: GET_MESSAGE_GROUPS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const createMessageGroup =
  (messageGroupData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_MESSAGE_GROUP_REQ,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const url = "/api/message-groups";
      const { data } = await api.post(url, messageGroupData, config);
      dispatch({
        type: CREATE_MESSAGE_GROUP_SUCCESS,
        payload: data?.body,
      });
      // fire event to create automation alarm for the extension
      // window.dispatchEvent(
      //   new CustomEvent('create-automation-settings', {
      //     bubbles: true,
      //     detail: {
      //       userEmail: userInfo.gmUsrEmail,
      //       automation: data?.body.automations,
      //     },
      //   })
      // );
      toast.success(data?.msg || "Message group created successfully");
    } catch (error) {
      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      dispatch({
        type: CREATE_MESSAGE_GROUP_FAIL,
      });

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const updateMessageGroup =
  (messageGroupData, messageGroupId = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_MESSAGE_GROUP_REQ,
      });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const url = `/api/message-groups/${messageGroupId}`;
      const { data } = await api.patch(url, messageGroupData, config);
      dispatch({
        type: UPDATE_MESSAGE_GROUP_SUCCESS,
        payload: data?.body,
      });
      // fire event to update automation alarm for the extension
      // window.dispatchEvent(
      //   new CustomEvent("update-automation-settings", {
      //     bubbles: true,
      //     detail: {
      //       userEmail: userInfo.gmUsrEmail,
      //       automation: data?.body,
      //     },
      //   })
      // );
      toast.success(data?.msg || "Message group details updated successfully");
    } catch (error) {
      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      dispatch({
        type: UPDATE_MESSAGE_GROUP_FAIL,
      });

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const deleteMessageGroup =
  (messageGroupId) => async (dispatch, getState) => {
    try {
      dispatch({ type: DELETE_MESSAGE_GROUP_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.delete(
        `/api/message-groups/${messageGroupId}`,
        config
      );

      dispatch({
        type: DELETE_MESSAGE_GROUP_SUCCESS,
        payload: messageGroupId,
      });

      // fire event to delete automation alarm for the extension
      // window.dispatchEvent(
      //   new CustomEvent("delete-automation-settings", {
      //     bubbles: true,
      //     detail: {
      //       userEmail: userInfo.gmUsrEmail,
      //       automationId: data?.body,
      //     },
      //   })
      // );

      toast.success("Message group deleted successfully");
    } catch (error) {
      dispatch({
        type: DELETE_MESSAGE_GROUP_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };
